export default __webpack_public_path__ + "static/media/feedbackManagementIcon.7168f2f4.svg";